import { helpers } from "../../util/index.ts";

// ============================================================================
// PER-PLAYER DEVELOPMENT VOLATILITY — fine-tune the RANGE of outcomes for
// specific players (how boom-or-bust their year-to-year growth is).
//
// One line per player. Keyed by Basketball-Reference slug (Player.srID, the
// same key data/real-player-data uses). Applied every preseason in
// developSeason.basketball.ts, and — because monteCarloPot runs that same
// simulation to project potential — a wider spread also lifts a boom
// prospect's reported `pot`. So this dial moves BOTH the realized outcomes
// and the potential number the UI shows.
//
//   value = 1    -> default BBGM spread (unchanged)
//   value > 1    -> WIDER range: bigger booms AND bigger busts
//   value < 1    -> NARROWER range: steadier, safer development
//
// It scales the standard deviation of the yearly growth draw; the per-year
// hard caps (a young player can still only swing about -4..+20 in a season)
// stay in place, so extreme values just push more mass toward those caps.
// Clamped to [0, 3].
// ============================================================================

export const DEVELOPMENT_VOLATILITY: Record<string, number> = {
	// Examples — uncomment and tune. Both of these are young players whose
	// outcome range you may want to widen or tighten:
	// "wilsoca01": 1.5, // Caleb Wilson — high-variance swing (bigger boom, bigger bust)
	// "dilliro01": 0.7, // Rob Dillingham — steadier, narrower range
};

// Look up a player's development volatility, defaulting to 1 (standard spread).
export const getVolatility = (srID: string | undefined): number => {
	if (srID === undefined) {
		return 1;
	}

	const v = DEVELOPMENT_VOLATILITY[srID];
	if (v === undefined) {
		return 1;
	}

	return helpers.bound(v, 0, 3);
};
